import { Select } from "@chakra-ui/react";
import { forwardRef } from "react";
import { useIntl } from "react-intl";
import { HOLDERS_DIETS_LIST } from "../../../constants/holders";

/**
 * @template {import("react-hook-form").FieldValues} TFieldValues
 * @template {import("react-hook-form").FieldPath<TFieldValues>} TName
 * @typedef {object} FieldProps
 * @property {import("react-hook-form").Control<TFieldValues>} [control]
 * @property {TName} name
 */

/**
 * @template {import("react-hook-form").FieldValues} TFieldValues
 * @template {import("react-hook-form").FieldPath<TFieldValues>} TName
 * @typedef {FieldProps<TFieldValues, TName> & Omit<import("@chakra-ui/react").SelectProps, "value">} Props
 */

const HoldersDietSelect = forwardRef(
  /**
   * @template {import("react-hook-form").FieldValues} TFieldValues
   * @template {import("react-hook-form").FieldPath<TFieldValues>} TName
   * @param {Props<TFieldValues, TName>} props
   */
  function HoldersDietSelect({ ...otherProps }, ref) {
    const intl = useIntl();

    return (
      <Select ref={ref} {...otherProps}>
        <option value="">-</option>

        {HOLDERS_DIETS_LIST.map?.((diet) => (
          <option value={diet.value} key={diet.value}>
            {intl.formatMessage(diet.name)}
          </option>
        ))}
      </Select>
    );
  },
);

/**
 * @type {<TFieldValues extends import("react-hook-form").FieldValues, TName extends import("react-hook-form").FieldPath<TFieldValues>>(props: Props<TFieldValues, TName>) => React.ReactElement}
 */
// @ts-ignore
export default HoldersDietSelect;
